/* eslint-disable */
import {NavigationBlock} from './NavigationBlock';
/**
* @description Interface for Avensia.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.stores.StoresNavigationBlock
*/
export interface StoresNavigationBlock extends NavigationBlock {
	
}
export const isStoresNavigationBlock = (model: unknown): model is StoresNavigationBlock => (model as StoresNavigationBlock).component === 'Bygghemma.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.stores.StoresNavigationBlock';

